import React, { Suspense, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import routes from "./routes/routes";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import DelayedLoader from "./components/DelayedLoader";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { setAccessToken } from "./api/axiosAuth";
import './css/Fonts.css';
import "./css/App.css";





function App() {
  // hydrate access token once on boot
  useEffect(() => {
    const saved = localStorage.getItem("accessToken");
    if (saved) setAccessToken(saved);
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>Pulse Robotics</title>
        <meta
          name="description"
          content="Pulse Robotics delivers cutting-edge robotics and financial solutions for modern businesses."
        />
        <link rel="canonical" href="https://www.pulserobotics.com" />
      </Helmet>
      <div className="app-container">
        <Navbar />
        <Suspense fallback={<DelayedLoader delay={500} />}>
          <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.component} />
            ))}
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;

